// Using canvas-confetti library for fireworks effect
export function launchConfetti() {
    // Create a script element to load the library if it's not already loaded
    if (!window.confetti) {
        loadConfettiLibrary().then(() => {
            prepareConfettiCanvas();
            startFireworks();
        });
    } else {
        prepareConfettiCanvas();
        startFireworks();
    }
}

function loadConfettiLibrary() {
    return new Promise((resolve) => {
        const script = document.createElement('script');
        script.onload = () => resolve();
        script.src = 'https://cdn.jsdelivr.net/npm/canvas-confetti@1.5.1/dist/confetti.browser.min.js';
        document.head.appendChild(script);
    });
}

// Create a canvas element inside the modal container to ensure proper z-index stacking
function prepareConfettiCanvas() {
    // Remove any existing confetti canvas
    const existingCanvas = document.getElementById('confetti-canvas');
    if (existingCanvas) {
        existingCanvas.remove();
    }

    // Get the modal container
    const modalContainer = document.querySelector('[x-data="congratulationsModal"]');
    if (!modalContainer) return;

    // Create the canvas element
    const canvas = document.createElement('canvas');
    canvas.id = 'confetti-canvas';
    canvas.style.position = 'absolute';
    canvas.style.inset = '0';
    canvas.style.width = '100%';
    canvas.style.height = '100%';
    canvas.style.zIndex = '55'; // Between backdrop (50) and modal content (60)
    canvas.style.pointerEvents = 'none'; // Allow clicks to pass through

    // Insert the canvas between the backdrop and modal content
    // First get the backdrop element
    const backdrop = modalContainer.querySelector('.bg-\\[\\#002870\\]\\/50');

    if (backdrop && backdrop.nextSibling) {
        // Insert the canvas after the backdrop but before the modal content
        modalContainer.insertBefore(canvas, backdrop.nextSibling);
    } else {
        // Fallback - just append to the modal container
        modalContainer.appendChild(canvas);
    }

    // Make sure canvas dimensions match container
    canvas.width = modalContainer.offsetWidth;
    canvas.height = modalContainer.offsetHeight;

    // Override the default confetti canvas
    window.confettiCanvas = canvas;
}

function startFireworks() {
    const duration = 8 * 1000; // Extended to 8 seconds
    const animationEnd = Date.now() + duration;
    const defaultColors = ['#ff0000', '#ff7700', '#ffff00', '#00ff00', '#0077ff', '#9900ff'];

    // Configure confetti to use our canvas instead of creating a new one
    const customCanvas = document.getElementById('confetti-canvas');
    if (!customCanvas) return;

    const myConfetti = confetti.create(customCanvas, {
        resize: true,
        useWorker: true
    });

    const defaults = {
        spread: 560,
        ticks: 60,
        gravity: 0.8,
        scalar: 1.2,
        disableForReducedMotion: true
    };

    function randomInRange(min, max) {
        return Math.random() * (max - min) + min;
    }

    // Regular fireworks function
    function fireFirework() {
        const timeLeft = animationEnd - Date.now();

        if (timeLeft <= 0) {
            return;
        }

        const particleCount = 60 * (timeLeft / duration);

        // Launch from random positions at the bottom
        myConfetti({
            ...defaults,
            particleCount,
            origin: { x: randomInRange(0.2, 0.8), y: randomInRange(0.8, 1) },
            colors: defaultColors,
            shapes: ['circle', 'square']
        });
    }

    // Spectacular firework with a circular burst pattern
    function fireBigBurst() {
        const timeLeft = animationEnd - Date.now();

        if (timeLeft <= 0) {
            return;
        }

        const position = {
            x: randomInRange(0.3, 0.7),
            y: randomInRange(0.35, 0.65)
        };

        // Create a large burst with lots of particles
        myConfetti({
            ...defaults,
            particleCount: 150,
            origin: position,
            colors: ['#ff0000', '#ff7700', '#ffff00', '#00ff00', '#0077ff', '#9900ff'],
            startVelocity: 35,
            gravity: 0.7,
            shapes: ['circle', 'circle', 'square'],
            scalar: 1.5
        });
    }

    // Schedule regular fireworks
    const fireworkInterval = setInterval(() => {
        fireFirework();

        // Randomly trigger a big burst
        if (Math.random() < 0.3) {
            fireBigBurst();
        }

        // Check if animation should end
        if (Date.now() > animationEnd) {
            clearInterval(fireworkInterval);
        }
    }, 250);

    // Add final big crescendo bursts at the end
    setTimeout(() => {
        const crescendoInterval = setInterval(() => {
            fireBigBurst();
            fireFirework();

            // Stop after 1.5 seconds of crescendo
            if (Date.now() > animationEnd + 1500) {
                clearInterval(crescendoInterval);

                // Clean up when animation is done
                setTimeout(() => {
                    if (customCanvas && customCanvas.parentNode) {
                        customCanvas.parentNode.removeChild(customCanvas);
                    }
                }, 500);
            }
        }, 150);
    }, duration - 1500);

    // Initial celebration burst
    fireFirework();
    setTimeout(fireBigBurst, 300);
}
